/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { User } from './User';
import {
    UserFromJSON,
    UserFromJSONTyped,
    UserToJSON,
    UserToJSONTyped,
} from './User';

/**
 * List of company members.
 * @export
 * @interface ListUsersInCompanyResponse
 */
export interface ListUsersInCompanyResponse {
    /**
     * 
     * @type {Array<User>}
     * @memberof ListUsersInCompanyResponse
     */
    members: Array<User>;
}

/**
 * Check if a given object implements the ListUsersInCompanyResponse interface.
 */
export function instanceOfListUsersInCompanyResponse(value: object): value is ListUsersInCompanyResponse {
    if (!('members' in value) || value['members'] === undefined) return false;
    return true;
}

export function ListUsersInCompanyResponseFromJSON(json: any): ListUsersInCompanyResponse {
    return ListUsersInCompanyResponseFromJSONTyped(json, false);
}

export function ListUsersInCompanyResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListUsersInCompanyResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'members': ((json['members'] as Array<any>).map(UserFromJSON)),
    };
}

export function ListUsersInCompanyResponseToJSON(json: any): ListUsersInCompanyResponse {
    return ListUsersInCompanyResponseToJSONTyped(json, false);
}

export function ListUsersInCompanyResponseToJSONTyped(value?: ListUsersInCompanyResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'members': ((value['members'] as Array<any>).map(UserToJSON)),
    };
}

